define('home/collections/CategoryCollection',[
    'underscore',
    'backbone',

    'core/api',
    'core/UniqueModel',

    'home/activityExpander',
    'home/models/Channel',
], function (
    _,
    Backbone,

    api,
    UniqueModel,

    activityExpander,
    Channel
) {
    'use strict';

    var _instance;

    /**
     * A collection of Channel models marked as Categories.
     *
     * Implemented as a singleton, since there is only 1 categories
     * list. Should be accessed using get.
     */
    var CategoryCollection = Backbone.Collection.extend({
        url: api.getURL('channels/listCategories'),
        model: UniqueModel.boundModel(Channel),

        parse: function (response) {
            response = Backbone.Collection.prototype.parse.call(this, response.response);

            // Endpoints uses reference/objects mapping for channels, which are expanded using
            // activityExpander
            return _.map(response.items, function (listedChannel) {
                return activityExpander.buildChannel(response.objects, listedChannel.reference);
            });
        },
    }, {
        get: function () {
            if (!_instance) {
                _instance = new CategoryCollection();
                _instance.fetch();
            }

            return _instance;
        },
    });

    return CategoryCollection;
});

